module.exports = __webpack_public_path__ + "static/media/vegetarian.61708d3c.svg";